import useSWR from "swr"

const useGranularity = (datasetValue, ticker) => {
    const {data: granularityOptions} = useSWR(datasetValue && `/api/getGranularityOptions?dataset=${datasetValue}&ticker=${ticker}`)

    return { granularityOptions }
}

export default useGranularity